import React from "react";
import { Route, Routes } from "react-router";
import ServiceObjectsPage from "./ServiceObjectsPage";
import ServiceObjectDetailPage from "./ServiceObjectDetailPage";

const ServiceObjectsShell: React.FC = (): React.ReactElement => {
  return (
    <Routes>
      <Route path="/:serviceObjectId" element={<ServiceObjectDetailPage />} />
      <Route index element={<ServiceObjectsPage />} />
    </Routes>
  );
};

export default ServiceObjectsShell;
